@if (showPrompt()) {
<div class="cookie-consent-backdrop" aria-hidden="true"></div>
<section
  class="cookie-consent-modal"
  role="dialog"
  aria-modal="true"
  aria-labelledby="cookie-consent-title"
>
  <div class="cookie-consent-card">
    <p class="cookie-consent-eyebrow">Cookie Notice</p>
    <h2 id="cookie-consent-title">This site uses cookies</h2>
    <p>
      Hebern uses cookies to keep you signed in and to support secure account
      features. You can accept cookies or continue without them. Without
      acceptance, sign-in cookies will not be created.
    </p>
    <p class="cookie-consent-policy">
      Learn more in our
      <a
        routerLink="/privacy-policy/document"
        target="_blank"
        rel="noopener noreferrer"
        >Privacy Policy</a
      >.
    </p>

    @if (errorMessage()) {
    <div class="cookie-consent-alert">{{ errorMessage() }}</div>
    }

    <div class="cookie-consent-actions">
      <button
        type="button"
        class="cookie-consent-action cookie-consent-action--secondary"
        [disabled]="isSubmitting"
        (click)="decline($event)"
      >
        Decline
      </button>
      <button
        type="button"
        class="cookie-consent-action"
        [disabled]="isSubmitting"
        (click)="accept($event)"
      >
        {{ isSubmitting ? 'Saving...' : 'Accept Cookies' }}
      </button>
    </div>
  </div>
</section>
}
